import { render, staticRenderFns } from "./GenericPopups.vue?vue&type=template&id=04997d7c"
import script from "./GenericPopups.vue?vue&type=script&lang=js"
export * from "./GenericPopups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports